<template>
  <div class="background-container">
    <Header
      :isHeaderShow="true"
      @toggle-side="isShowSideMenu = !isShowSideMenu"
    />
    <SideMenu
      :isShow="isShowSideMenu"
      @toggle-show="isShowSideMenu = !isShowSideMenu"
    />
    <div class="default-container">
      <div class="blog-index-title-box">
        <h1 class="blog-index-title">띵동! 홈핏입니다👋</h1>
        <p class="blog-index-desc">
          국내 1위 방문 PT 홈핏의 소식을 한 눈에 확인해 보세요!
        </p>
      </div>

      <div class="blog-index-tab-container" v-if="categories.length > 2">
        <div
          v-for="category in categories"
          :id="'tab_' + category.id"
          :key="category.id"
          :class="{ active: category.id === selectedCategory }"
          class="blog-index-tab-box"
          @click="clickPcTab($event, category.id)"
        >
          <a :href="`?category=${category.id}`">{{ category.name }}</a>
        </div>
      </div>

      <div class="blog-index-list-container">
        <div
          v-for="content in categoryContents(selectedCategory)"
          :key="content.id"
          class="blog-index-list-item-box"
        >
          <div @click="moveToBoardView($event, content.id)">
            <div class="blog-index-item-img">
              <img :data-src="content.thumbUrl" class="lazy" />
            </div>
            <div class="blog-index-item-category-box">
              <div
                v-for="category in content.categories"
                :key="category.id"
                class="blog-index-item-category"
                @click="clickPcTab($event, category.id)"
              >
                <a :href="`?category=${category.id}`">{{ category.name }}</a>
              </div>
            </div>
            <div class="blog-index-item-title" v-html="content.title"></div>
            <time v-if="content.publishedAt && !content.isHidePublicationDate" :datetime="content.publishedAt" :aria-label="'발행일 ' + content.publishedAtLabel" style="color: #797979; font-size: 13px;">
              {{ content.publishedAtLabel }}
            </time>
          </div>
        </div>
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="spinner"></div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </div>
    <Footer width="906px" />
    <div
      class="channel-talk que_btn"
      @click="handlerClickChannelTalkButton"
    ></div>
  </div>
</template>

<script>
import axios from 'axios'
import { get } from 'lodash'
import helpers from '@/assets/js/helpers'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'HomefitStoryV2',
  components: {
    Header: () => import('@/components/common/CommonHeaderV2'),
    Footer: () => import('@/components/common/CommonFooterV2'),
    SideMenu: () => import('@/components/common/CommonHeaderV2SideMenu'),
    InfiniteLoading
  },
  data() {
    return {
      perPage: 100,
      page: 0,
      categories: [{ id: 'all', name: '전체' }],
      contents: [],
      selectedCategory: 'all',
      isShowSideMenu: false,
      infiniteId: 1
    }
  },
  computed: {
    categoryContents() {
      return category => {
        if (category === 'all') {
          return this.contents
        } else {
          return this.contents.filter(c =>
            c.categories.map(cc => cc.id).includes(category)
          )
        }
      }
    }
  },
  created() {
    window.UIkit.sticky(
      document.querySelector('.hf_layout_header_uikit_wrap '),
      null
    )
    document.querySelector('.hf_layout_header_uikit_wrap').style.display =
      'none'

    this.fetchCategories().then(() => {
      this.initializeSelectedCategory()
    })
  },
  mounted() {
    setTimeout(() => {
      window.ChannelIO('boot', {
        pluginKey: '53a60258-6cf5-4846-9848-becfb024e3ba',
        memberId: window.homefit?.user?.encryptedId,
        customLauncherSelector: '.que_btn',
        hideChannelButtonOnBoot: false
      })

      window.dispatchEvent(new Event('resize'))
    }, 300)
  },
  updated() {
    this.$nextTick(function() {
      window.homefit.lazyLoadImage()
    })
  },
  watch: {
    selectedCategory() {
      window.history.replaceState(
        null,
        '',
        '?category=' + this.selectedCategory
      )
    }
  },
  methods: {
    async fetchCategories() {
      const response = await axios.post('/api/board/wordpress/categories/', {
        _method: 'get'
      })
      this.categories = this.categories.concat(response.data.categories)
    },
    async fetchContents(category) {
      this.page++
      const response = await axios.post('/api/board/wordpress/posts/', {
        _method: 'get',
        page: this.page,
        category
      })
      return response.data.index
    },
    initializeSelectedCategory() {
      const category = helpers.getQueryParameter().category
      if (category) {
        this.selectedCategory = category === 'all' ? category : Number(category)
      }
    },
    moveToBoardView(e, x) {
      if (get(e, 'isTrusted') == false) {
        return
      }
      location.href = `/board/view-v2/?id=${x}`
    },
    clickPcTab(event, c) {
      event.preventDefault()
      if (!c) {
        return
      }
      this.page = 0
      this.selectedCategory = c
      this.infiniteId++
    },
    handlerClickChannelTalkButton() {
      setTimeout(() => {
        window.scrollTo({ top: 10 })
      }, 100)
    },
    infiniteHandler($state) {
      this.fetchContents().then(fetchedContents => {
        if (this.page > 1) {
          this.contents = this.contents.concat(fetchedContents)
        } else {
          this.contents = fetchedContents
        }
        if (fetchedContents.length < this.perPage) {
          $state.complete()
        } else {
          $state.loaded()
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import url('https://cdn.jsdelivr.net/npm/xeicon@2.3.3/xeicon.min.css');
@import url('https://dcse8twossp9.cloudfront.net/static/partner/hamlet/step2/css/style.css');
@import url('https://dcse8twossp9.cloudfront.net/static/partner/hamlet/step2/css/reset.css');
@import 'assets/step2/css/s2_08.css';
@import '@/assets/scss/_index.scss';
@import '@/assets/scss/board/board-index.scss';
</style>
